module.exports = __webpack_public_path__ + "static/media/correct-02.f7e5bdc7.png";